var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.flightResult.route, function (route) {
      return _c("div", { staticClass: "row flight-route" }, [
        _c("div", {
          staticClass:
            "column small-4 small-order-1 medium-order-0 medium-2 small-text-right",
          domProps: { innerHTML: _vm._s(route.logos) },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column small-8 small-order-0 medium-order-1 medium-3",
          },
          [
            _c("div", { staticClass: "airport-name" }, [
              _vm._v(_vm._s(route.from.departure_airport_name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "airport-datetime text-xsmall" }, [
              _vm._v(_vm._s(route.from.departure_date_time)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column small-12 small-order-2 medium-3 text-center spacer-small",
          },
          [
            _c("div", {
              staticClass: "airport-stops",
              domProps: { innerHTML: _vm._s(route.time_and_stops) },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "route-vias",
                on: { click: _vm.emitShowFlightPlan },
              },
              [
                _c("div", { staticClass: "via" }, [
                  _vm._v(_vm._s(_vm.flightResult.cabin_type)),
                ]),
                _vm._v(" "),
                route.via.length > 0
                  ? _c("div", { staticClass: "via" }, [_vm._v("via")])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(route.via, function (v) {
                  return _c(
                    "div",
                    { staticClass: "via", attrs: { title: v.name } },
                    [_vm._v("\n          " + _vm._s(v.name) + "\n        ")]
                  )
                }),
                _vm._v(" "),
                _c("span", { staticClass: "info-icon" }, [_vm._v("i")]),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column small-12 medium-3 small-order-3 text-right" },
          [
            _c("div", { staticClass: "airport-name" }, [
              _vm._v(_vm._s(route.to.destination_airport_name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "airport-datetime text-xsmall" }, [
              _vm._v(_vm._s(route.to.arrival_date_time)),
            ]),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }